<template>
  <section class="black-bg">
    <div class="booksheetContainer">
      <div class="wrap container-fluid" id="register">
        <img src="../assets/ornament_rotator.svg" class="rotator" />
        <img src="../assets/hash.svg" class="hash" />
        <div class="around-md">
          <div>
            <div class="sold-out">
              <h6>Registration is closed.</h6>
              <p>
                But you also can <u>subscribe</u> and receive email for furthur
                notice and updates about the event happenings.
              </p>
            </div>

            <div class="form-group">
              <label for="email" class="form-label">Email Address</label>
              <input
                type="email"
                id="email"
                placeholder="eg: you@mail.com"
                class="form-control"
                v-model="update.email"
                @change="validate"
              />
              <span class="form-error">{{ errors[0] }}</span>
            </div>

            <div class="form-bottom">
              <button
                :disabled="isDisabled"
                class="btn btn-lg"
                type="submit"
                @click="onSubmit"
              >
                Keep Me Updated<span class="btn-stroke"></span>
              </button>
              <div class="form-submitted" v-show="submission">
                🥳 Congratulations! Your form is submitted.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { storeDataToBase } from "../services/storeDataToBase";

export default {
  name: "FutureUpdates",
  data() {
    return {
      update: {
        email: "",
      },
      errors: [],
      submission: false,
      isDisabled: false,
    };
  },
  methods: {
    validate: function () {
      // clearing any previous errors
      this.errors = [];

      // Valid email regex
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

      let error = this.update.email === "" ?   "The Email field is required." : (!reg.test(this.update.email)) ? 'The Email field must have a valid email address.' : '';

      if(error){
        this.errors.push(error)
      }
    },
    onSubmit: async function () {
      try {
        this.validate();
        if (this.errors.length === 0) {
          this.isDisabled = true;
          const fields = [
            {
              fields: this.update,
            },
          ];
          await storeDataToBase("updates", fields);
          this.submission = true;
          setTimeout(() => {
            this.submission = false;
            this.isDisabled = false;
            this.errors = [];
            this.update = {
              email: "",
            };
          }, 3000);
        }
      } catch (e) {
        alert("We are unable to subscribe to your email!");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.booksheetContainer {
  max-width: 920px;
  margin: auto;
  padding: 6rem 2.5rem;
  margin-bottom: 4rem;
  position: relative;
}
.hero-subheading {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 1.5rem;
  color: var(--text-white);
}
.hero-subheading .text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}
.form-control {
  border: none;
  background-color: var(--bg-black);
  outline: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  padding-top: 0.5rem;
  font-size: 1.2rem;
  color: #ebebeb;
}
.form-bottom {
  display: flex;
  align-items: center;
}
.form-group {
  background-color: var(--bg-black);
}
.sold-out h6 {
  color: var(--text-white);
  font-size: 2.2rem;
  margin: 0rem;
}
.sold-out p {
  margin: 1rem 0rem 3rem 0rem;
  color: var(--text-white);
  font-size: 1.2rem;
}
.sold-out p > u {
  color: var(--primary-color);
}
.form-group:focus-within {
  border-color: var(--primary-color);
}
.form-group .form-error {
  display: block;
  font-weight: bold;
  padding: 0.5rem 1rem 0 1rem;
  color: red;
}
.form-select select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.form-select:after {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  right: 0;
  margin: -3rem 2rem;
  border: 2px solid var(--lighter-grey);
  position: absolute;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.form-small {
  display: block;
  color: var(--lighter-grey);
  padding: 1rem 0;
}
.form-submitted {
  color: var(--primary-color);
  margin-left: 1rem;
}
.rotator {
  width: 410px;
  opacity: 0.25;
  position: absolute;
  right: -450px;
}
.hash {
  width: 25%;
  opacity: 0.25;
  position: absolute;
  left: -45%;
  top: 80%;
}
.form-control > option {
  color: var(--text-grey);
}
@media (max-width: 576px) {
  .rotator {
    right: -30%;
  }
  .booksheetContainer {
    overflow: hidden;
  }
}
@media (max-width: 992px) {
  .rotator {
    right: -30%;
  }
}
</style>
